import { Pressable, StyleSheet } from "react-native";
import { useNavigation } from "@src/hooks";
import type { ReactNode } from "react";
import type { StyleProp, ViewStyle } from "react-native";

type AppInfoLongPressableProps = {
  readonly children: ReactNode;
  readonly style?: StyleProp<ViewStyle>;
};

export const AppInfoLongPressable = ({ children, style }: AppInfoLongPressableProps) => {
  const styles = StyleSheet.create<{
    readonly container: ViewStyle;
  }>({
    container: {
      cursor: "auto",
    },
  });
  const navigation = useNavigation();

  return (
    <Pressable
      onLongPress={() => {
        navigation.push("AppInfo");
      }}
      style={[styles.container, style]}
    >
      {children}
    </Pressable>
  );
};
